import React from "react";
import { SFTypography } from "@sf-core";

export const HighlightText = (text, searchTerm = "") => {
  let parts = text.split(new RegExp("(" + searchTerm + ")", "gi"));
  if (!searchTerm) {
    return text;
  }
  
  return (
    <>
      {parts.map(function (part, index) {
        if (part.toLowerCase() === searchTerm.toLowerCase()) {
          return (
            <SFTypography
              sx={{ fontWeight: 700 }}
              component="span"
              color="red"
              key={index}
            >
              {part}
            </SFTypography>
          );
        }
        return part;
      })}
    </>
  );
};
